import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const Login = () => {
    const [error, setError] = useState(null);
    const [isHovered, setIsHovered] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        // The new backend sends 'error=true' on failure.
        // We can display a generic message.
        if (queryParams.get('error')) {
            setError("Login failed. Please try again.");
        }
    }, [location]);

    const backendUrl = window.env?.BACKEND_URL || 'http://localhost:3001';
    const loginUrl = `${backendUrl}/auth/microsoft`;

    const pageStyle = {
        fontFamily: "'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        margin: 0,
        backgroundColor: '#f0f2f5'
    };

    const cardStyle = {
        textAlign: 'center',
        background: 'white',
        padding: '50px 40px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '360px'
    };

    const logoStyle = {
        width: '180px',
        marginBottom: '30px'
    };

    const buttonStyle = {
        backgroundColor: '#0078D4',
        color: 'white',
        border: 'none',
        padding: '12px 24px',
        fontSize: '16px',
        borderRadius: '8px',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        textDecoration: 'none',
        transition: 'background-color 0.3s ease, transform 0.1s ease',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        transform: isHovered ? 'scale(1.03)' : 'scale(1)'
    };

    return (
        <div style={pageStyle}>
            <div style={cardStyle}>
                <img src="https://i.ibb.co/DfXdPcVd/Quanterm-Official-Logo-High-Reso-01.png" alt="Company Logo" style={logoStyle} />
                {error && <p style={{ color: '#d93025', marginBottom: '20px' }}>Authentication Failed: {error}</p>}
                <a
                    href={loginUrl}
                    style={buttonStyle}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <img src="https://img.icons8.com/color/48/000000/microsoft.png" alt="Microsoft Logo" style={{ width: '24px', marginRight: '12px' }} />
                    Sign in with Microsoft
                </a>
            </div>
        </div>
    );
};

export default Login;

